module.exports = __webpack_public_path__ + "static/media/WAF2_13Feb1983.905e8c79.jpg";